const styles = (theme) => ({
  infoBox: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 20,
    padding: 20,
  },
})

export default styles
